import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export default function Sidebar() {
  const { authUser, logout } = useAuthStore();
  const location = useLocation();


  const isActive = (path) =>
    location.pathname === path
      ? "bg-neutral-100 text-neutral-900"
      : "text-neutral-700 hover:bg-neutral-100";

  return (
    <div id="sidebar" className="w-64 bg-white border-r border-neutral-200 shadow-sm flex flex-col">
      <div className="p-4">
        <div className="flex items-center space-x-2 mb-8">
          <div className="w-8 h-8 bg-neutral-800 rounded-md flex items-center justify-center">
            <i className="fa-solid fa-layer-group text-white"></i>
          </div>
          <span className="text-lg">5 Star Grading</span>
        </div>

        <nav className="space-y-1">
          <Link to="/" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/")}`}>
            <i className="fa-solid fa-home w-5 mr-3"></i>
            <span>Dashboard</span>
          </Link>

          <Link to="/home" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/home")}`}>
            <i className="fa-solid fa-house w-5 mr-3"></i>
            <span>Home</span>
          </Link>

          <Link to="/earthworks" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/earthworks")}`}>
            <i className="fa-solid fa-mountain w-5 mr-3"></i>
            <span>Earth Works</span>
          </Link>

          <Link to="/concrete" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/concrete")}`}>
            <i className="fa-solid fa-cubes w-5 mr-3"></i>
            <span>Concrete</span>
          </Link>

          <Link to="/utilities" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/utilities")}`}>
            <i className="fa-solid fa-water w-5 mr-3"></i>
            <span>Utilities</span>
          </Link>

          <Link to="/emergency" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/emergency")}`}>
            <i className="fa-solid fa-exclamation-triangle w-5 mr-3"></i>
            <span>Emergency</span>
          </Link>

          <Link to="/projects" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/projects")}`}>
            <i className="fa-solid fa-briefcase w-5 mr-3"></i>
            <span>Projects</span>
          </Link>

          <Link to="/aboutus" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/aboutus")}`}>
            <i className="fa-solid fa-info-circle w-5 mr-3"></i>
            <span>About Us</span>
          </Link>
          <Link to="/gallery" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/gallery")}`}>
            <i className="fa-solid fa-image w-5 mr-3"></i>
            <span>Gallery</span>
          </Link>

          <Link to="/testimonial" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/testimonial")}`}>
            <i className="fa-solid fa-quote-left w-5 mr-3"></i>
            <span>Testimonial</span>
          </Link>

          <Link to="/contactus" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/contactus")}`}>
            <i className="fa-solid fa-envelope w-5 mr-3"></i>
            <span>Contact Us</span>
          </Link>

          <Link to="/query" className={`flex items-center px-3 py-2 rounded-md cursor-pointer ${isActive("/query")}`}>
            <i className="fa-solid fa-clipboard-question w-5 mr-3"></i>
            <span>Email Requests</span>
          </Link>

          {/* <span className="flex items-center px-3 py-2 text-neutral-700 rounded-md hover:bg-neutral-100 cursor-pointer">
            <i className="fa-solid fa-users w-5 mr-3"></i>
            <span>Users</span>
          </span> */}
        </nav>
      </div>

      <div className="mt-auto p-4 border-t border-neutral-200">
        {/*         <span className="flex items-center px-3 py-2 text-neutral-700 rounded-md hover:bg-neutral-100 cursor-pointer">
          <i className="fa-solid fa-cog w-5 mr-3"></i>
          <span>Settings</span>
        </span> */}
        <div
          onClick={() => logout()}
          className="flex items-center px-3 py-2 text-neutral-700 rounded-md hover:bg-neutral-100 mt-2 cursor-pointer"
        >
          <i className="fa-solid fa-sign-out-alt w-5 mr-3"></i>
          <span>Logout</span>
        </div>
      </div>
    </div>
  );
}
